import { Locale } from '../i18n/config';

export interface CooperateItem {
  type: string;
  imgUrl: string;
  imgUrl_m: string;
  name: string;
  name_en: string;
  id: string;
}

export interface CooperateCategoryItem {
  id: string;
  title: string;
  title_en: string;
  cooperateList: CooperateItem[];
}

export interface MarqueeItem {
  id: string;
  imgUrl: string;
  link: string;
  desc: string;
  desc_en: string;
}

export interface MeetingMsgItem {
  guideReadText: string;
  id: string;
  imgUrl: string;
  link: string;
  mediaTag: string;
  time: string;
  title: string;
}

export interface GuestItem {
  /** 人物头像图片URL */
  avatar: string;
  /** 讨论主题（中文）- 此处为“生命急救场景” */
  discussionTopic: string;
  /** 讨论主题（英文）- 当前为占位符 */
  discussionTopic_en: string;
  /** 唯一标识ID */
  id: string;
  /** 人物详细介绍（中文） */
  intro: string;
  /** 人物详细介绍（英文）- 当前为占位符 */
  intro_en: string;
  /** 人物姓名（中文） */
  name: string;
  /** 人物姓名（英文）- 当前为占位符 */
  name_en: string;
  /** 人物头衔（中文）多个头衔以分号分隔 - 如“中国企业改革与发展研究会会长;国务院国资委原党委委员、秘书长” */
  title: string;
  /** 人物头衔（英文）多个头衔以分号分隔 - 当前为占位符 */
  title_en: string;
}

export interface MeetingItem {
  id: string;
  title: string;
  title_en: string;
  timeText: string;
  speakerImgUrl: string;
  speaker: GuestItem[];
}

export interface MeetingParagraphItem {
  id: string;
  title: string;
  title_en: string;
  timeText: string;
  meetingList: MeetingItem[];
}

export interface VideoItem {
  id: string;
  title: string;
  title_en: string;
  poster: string;
  url: string;
}
export interface VideoReviewItem {
  desc: string;
  desc_en: string;
  id: string;
  name: string;
  name_en: string;
  videoList: VideoItem[];
}

export interface AgendaReviewItem {
  desc: string;
  desc_en: string;
  id: string;
  name: string;
  name_en: string;
  meetingList: MeetingItem[];
}
export interface ForumItem {
  desc: string;
  desc_en: string;
  id: string;
  name: string;
  name_en: string;
  guestList: GuestItem[];
  meetingParagraphList: MeetingParagraphItem[];
  isMtListHidden: boolean;
  isGuestListHidden: boolean;
}

export type ExhibitionAreaTContext = {
  [K in Locale]: {
    title: string;
    pList: string[];
  }[];
};

export interface ExhibitionAreaItem {
  /** 发布会详情内容（包含中英文JSON，规则例：{[language]:{"title": "xxxx",pList:["xxxx","xxxx"]}}） */
  content: string;
  /** 转换后的发布会详情内容（包含中英文JSON，规则例：{[language]:{"title": "xxxx",pList:["xxxx","xxxx"]}}）*/
  tContent?: ExhibitionAreaTContext[Locale];
  /** 唯一标识ID（字符串格式，如"49400000001"） */
  id: string;
  /** 封面/相关图片的URL链接 */
  imgUrl: string;
  /** 中文名称（如"碳寻制造"） */
  name: string;
  /** 英文名称（如"碳寻制造"） */
  name_en: string;
  /** 中文标签（分号分隔，如"碳寻计划;碳寻工厂"） */
  tag: string;
  /** 英文标签（分号分隔，如"Carbon Search Plan;Carbon Search Factory"） */
  tag_en: string;
  /** 中文标题（如"「碳寻制造」 新品发布会"） */
  title: string;
  /** 英文标题（如"Carbon Search Manufacturing\" New Product Launch Conference"） */
  title_en: string;
  /** 展区编号 */
  areaNumber: number;
}

/** 大会介绍核心内容JSON转换后数据 */
export interface TCoreContent {
  title: string;
  desc: string;
  bgImage: string;
  bgImage_m: string;
  bgStyle: string;
  bgStyle_m: string;
  color: string;
}

/** 大会介绍数据 */
export interface MeetingIntroData {
  id: string;
  intro: string;
  intro_en: string;
  /** 会议介绍核心内容 - JSON格式 */
  coreContent: string;
  /** 会议介绍核心内容 - coreContent转换后的数据 */
  TCoreContent?: TCoreContent[];
}

// 大会主信息配置

export enum MeetingStatus {
  /** 未开始 */
  NotStarted = '1',
  /** 进行中 */
  InProgress = '2',
  /** 已结束 */
  Completed = '3',
  /** 精彩回顾 */
  Review = '4',
}

export interface MeetingMainConfig {
  status: MeetingStatus;
  liveQrCode: string;
  liveUrl: string;
  liveSourceUrl: string;
  liveQrCodeWx: string;
  liveQrCodeH5: string;
  intlRegisterInfo: string;
}

export interface IAiForGoodItem {
  id: string;
  logo: string;
  caseText: string;
  caseText_en: string;
  link: string;
  mobileLink: string;
  wxLink: string;
}

export interface IReportResourceItem {
  id: number;
  title: string;
  cover: string;
  url: string;
  year: string;
}

export enum MeetingModule {
  /** 大会主信息 */
  MeetingMainModule = 'meetingMainModule',
  /** 大会介绍 */
  MeetingIntroModule = 'meetingIntroModule',
  /** 与会嘉宾 */
  GuestModule = 'guestModule',
  /** 会议议程 */
  AgendaModule = 'agendaModule',
  /** 会议展区 */
  ExhibitionAreaModule = 'exhibitionAreaModule',
  /** 会议资讯 */
  MessageModule = 'messageModule',
  /** 会议回顾 */
  ReviewModule = 'reviewModule',
  /** 合作伙伴 */
  CooperateModule = 'cooperateModule',
  /** ai向善 */
  AiForGoodModule = 'aiForGoodModule',
  /** 精彩视频 */
  VideoReviewModule = 'videoReviewModule',
  /** 议程回顾 */
  AgendaReviewModule = 'agendaReviewModule',
  /** 精彩图片回顾 */
  ReviewImageModule = 'reviewImageModule',
  /** 下载报告 */
  ReportResourceModule = 'reportResourceModule',
}

export interface PageModuleItem {
  id: string;
  title: string;
  title_en: string;
  moduleName: MeetingModule;
  moduleDataKey: keyof CMSData;
  /** 大会状态权限规则， 逗号分隔，如：1,2,3,4 */
  rules: string;
  hidden: boolean;
}

export interface CMSData {
  forumList: ForumItem[];
  cooperateCategoryList: CooperateCategoryItem[];
  meetingReviewList: MarqueeItem[];
  meetingMsgList: MeetingMsgItem[];
  exhibitionAreaList: ExhibitionAreaItem[];
  pageModuleData: PageModuleItem[];
  meetingIntroData: MeetingIntroData[];
  meetingMainConfig: MeetingMainConfig[];
  aiForGoodList: IAiForGoodItem[];
  reportResourceList: IReportResourceItem[];
}
